import React from "react";

const OnboardProductLoadingOverlay = ({ isVisible, imageSrc }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
      <div className="flex flex-col items-center space-y-3">
        <img src={imageSrc} alt="Loading..." style={{ width : 200}}/>
        <span className="text-gray-700 text-[20px] text-center">
          Hang tight! The resources are loading...
        </span>
      </div>
    </div>
  );
};

export default OnboardProductLoadingOverlay;


